import React from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error(
            `[ErrorBoundary${this.props.label ? `:${this.props.label}` : ""}] ${error && error.stack}`,
            "\nComponent stack:", info.componentStack
        );
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    label: PropTypes.string
};

ErrorBoundary.defaultProps = {
    label: ""
};

export default ErrorBoundary;
